import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "perArchiveMgr-container"
  }, [_c('a-space', {
    staticClass: "line-space",
    attrs: {
      "direction": "vertical"
    }
  }, [_c('a-card', {
    attrs: {
      "size": "small"
    }
  }, [_c('a-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('a-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("个人档案")])])]), _c('a-col', {
    attrs: {
      "span": 20
    }
  }, [_c('a-space', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm.mode == 'add' ? _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" 保存 ")]) : _vm._e(), _vm.mode == 'edit' ? _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v(" 保存 ")]) : _vm._e(), _c('a-button', {
    on: {
      "click": _vm.rutrnBack
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)], 1), _c('a-card', {
    staticClass: "body-content",
    attrs: {
      "size": "small"
    }
  }, [_c('a-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('a-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-avatar', {
    attrs: {
      "src": _vm.avatarUrl,
      "size": 150,
      "shape": "circle"
    }
  }), _c('br'), _c('a-upload', {
    attrs: {
      "name": "file",
      "action": "api/personArchivesController/uploadImg",
      "headers": _vm.headers,
      "show-upload-list": false,
      "accept": ".jpg,.png"
    },
    on: {
      "change": _vm.handleChangeAvatar
    }
  }, [_vm.mode == 'view' ? _c('a-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "size": "small"
    }
  }, [_vm._v(" 更换头像 ")]) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "anchor-content"
  }, _vm._l(_vm.anchorList, function (item, index) {
    return _c('div', {
      key: item.id,
      class: _vm.current == index ? 'anchor-item-seleted' : 'anchor-item',
      on: {
        "click": function click($event) {
          return _vm.handleClick(index, item.id);
        }
      }
    }, [_c('a-row', [_c('a-col', {
      attrs: {
        "span": 6
      }
    }, [item.id == 'jbxx' ? _c('span', {
      staticClass: "iconfont icon-jibenxinxi",
      staticStyle: {
        "font-size": "24px",
        "color": "#606266"
      }
    }) : _vm._e(), item.id == 'gwxx' ? _c('span', {
      staticClass: "iconfont icon-zhiwei",
      staticStyle: {
        "font-size": "28px",
        "color": "#606266"
      }
    }) : _vm._e(), item.id == 'xlxx' ? _c('span', {
      staticClass: "iconfont icon-fenqixueli",
      staticStyle: {
        "font-size": "24px",
        "color": "#606266"
      }
    }) : _vm._e(), item.id == 'zczs' ? _c('span', {
      staticClass: "iconfont icon-zhicheng",
      staticStyle: {
        "font-size": "28px",
        "color": "#606266"
      }
    }) : _vm._e(), item.id == 'gzjl' ? _c('span', {
      staticClass: "iconfont icon-gongzuojingli",
      staticStyle: {
        "font-size": "24px",
        "color": "#606266"
      }
    }) : _vm._e(), item.id == 'pthzs' ? _c('span', {
      staticClass: "iconfont icon-putonghua",
      staticStyle: {
        "font-size": "22px",
        "color": "#606266"
      }
    }) : _vm._e(), item.id == 'qmtp' ? _c('span', {
      staticClass: "iconfont icon-icon_dianziqianming",
      staticStyle: {
        "font-size": "24px",
        "color": "#606266"
      }
    }) : _vm._e(), item.id == 'jszgz' ? _c('span', {
      staticClass: "iconfont icon-jiaoshizigezheng",
      staticStyle: {
        "font-size": "26px",
        "color": "#606266"
      }
    }) : _vm._e()]), _c('a-col', {
      attrs: {
        "span": 18
      }
    }, [_c('span', {
      key: item.id
    }, [_vm._v(" " + _vm._s(item.name) + " ")])])], 1)], 1);
  }), 0)]), _c('a-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    ref: "infobody",
    staticClass: "info-body"
  }, [_c('a-form-model', {
    ref: "infoForm",
    staticClass: "myForm",
    attrs: {
      "model": _vm.infoForm,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "info-title",
    attrs: {
      "id": "jbxx"
    }
  }, [_c('span', [_vm._v("基本信息")])]), _c('div', {
    staticClass: "form-content"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "姓名",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "name"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入姓名",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "name", $$v);
      },
      expression: "infoForm.name"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "家庭住址",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "homeAddress"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入家庭住址",
      "disabled": _vm.mode == 'view',
      "placeholder-style": "{'color':'#000'}"
    },
    model: {
      value: _vm.infoForm.homeAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "homeAddress", $$v);
      },
      expression: "infoForm.homeAddress"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "性别",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "sex"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.sex,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "sex", $$v);
      },
      expression: "infoForm.sex"
    }
  }, _vm._l(_vm.sexDict, function (item) {
    return _c('a-select-option', {
      key: item.id
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "健康状况",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "physicalCondition"
    }
  }, [_c('a-select', {
    staticClass: "myselect",
    attrs: {
      "placeholder": "请选择健康状况",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.physicalCondition,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "physicalCondition", $$v);
      },
      expression: "infoForm.physicalCondition"
    }
  }, [_vm._l(_vm.healthDictTree, function (item) {
    return _c('a-select-opt-group', {
      key: item.code,
      attrs: {
        "label": item.name
      }
    }, _vm._l(item.children, function (opt) {
      return _c('a-select-option', {
        key: opt.code
      }, [_vm._v(" " + _vm._s(opt.name) + " ")]);
    }), 1);
  }), _vm._l(_vm.healthDictOpt, function (opt) {
    return _c('a-select-option', {
      key: opt.code
    }, [_vm._v(" " + _vm._s(opt.name) + " ")]);
  })], 2)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "身份证号码",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "idCard"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入身份证号",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.idCard,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "idCard", $$v);
      },
      expression: "infoForm.idCard"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "婚姻状况",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "maritalStatus"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择婚姻状况",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.maritalStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "maritalStatus", $$v);
      },
      expression: "infoForm.maritalStatus"
    }
  }, _vm._l(_vm.marriageDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "年龄",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "age"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "type": "number",
      "placeholder": "请输入年龄",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.age,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "age", $$v);
      },
      expression: "infoForm.age"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "学历性质",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "degreeInNature"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择学历性质 ",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.degreeInNature,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "degreeInNature", $$v);
      },
      expression: "infoForm.degreeInNature"
    }
  }, _vm._l(_vm.degreeNatureDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "民族",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "nation"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择民族",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.nation,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "nation", $$v);
      },
      expression: "infoForm.nation"
    }
  }, _vm._l(_vm.nationDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "办公座机",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "officeTel"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "请输入办公座机",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.officeTel,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "officeTel", $$v);
      },
      expression: "infoForm.officeTel"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "籍贯",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "nativePlace"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入籍贯",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.nativePlace,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "nativePlace", $$v);
      },
      expression: "infoForm.nativePlace"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "紧急联系人",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "emergencyContact"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入紧急联系人",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.emergencyContact,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "emergencyContact", $$v);
      },
      expression: "infoForm.emergencyContact"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "政治面貌",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "politicsStatus"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择政治面貌",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.politicsStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "politicsStatus", $$v);
      },
      expression: "infoForm.politicsStatus"
    }
  }, _vm._l(_vm.politicsStatusDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "紧急联系人电话",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "emergencyContactPhone"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "请输入紧急联系人电话",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.emergencyContactPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "emergencyContactPhone", $$v);
      },
      expression: "infoForm.emergencyContactPhone"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "本人手机号码",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "mobile"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "请输入本人手机号码",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.mobile,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "mobile", $$v);
      },
      expression: "infoForm.mobile"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "用工方式",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "modeOfEmployment"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择用工方式",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.modeOfEmployment,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "modeOfEmployment", $$v);
      },
      expression: "infoForm.modeOfEmployment"
    }
  }, _vm._l(_vm.modeOfEmploymentDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "出生地",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "birthPlace"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入出生地",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.birthPlace,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "birthPlace", $$v);
      },
      expression: "infoForm.birthPlace"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "编制类型",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "prepareType"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择编制类型",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.prepareType,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "prepareType", $$v);
      },
      expression: "infoForm.prepareType"
    }
  }, _vm._l(_vm.prepareTypeDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "证件类型",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "certType"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择证件类型",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.certType,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "certType", $$v);
      },
      expression: "infoForm.certType"
    }
  }, _vm._l(_vm.certTypeDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否使用统一用户平台",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "isApplicable"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择是否使用统一用户平台",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.isApplicable,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "isApplicable", $$v);
      },
      expression: "infoForm.isApplicable"
    }
  }, _vm._l(_vm.isApplicableDict, function (item) {
    return _c('a-select-option', {
      key: item.id
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "户口性质",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "householdRegistrationType"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择户口性质",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.householdRegistrationType,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "householdRegistrationType", $$v);
      },
      expression: "infoForm.householdRegistrationType"
    }
  }, _vm._l(_vm.householdRegistrationTypeDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "info-title",
    attrs: {
      "id": "xlxx"
    }
  }, [_c('span', [_vm._v("学历信息")])]), _c('div', {
    staticClass: "form-content"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "初始学历",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "initDegree"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入初始学历",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.initDegree,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "initDegree", $$v);
      },
      expression: "infoForm.initDegree"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "初始学历毕业时间",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "initGraduationDate"
    }
  }, [_c('a-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择初始学历毕业时间",
      "disabled": _vm.mode == 'view',
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.infoForm.initGraduationDate,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "initGraduationDate", $$v);
      },
      expression: "infoForm.initGraduationDate"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "初始学历毕业院校",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "initDegreeFromUniversity"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入初始学历毕业院校",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.initDegreeFromUniversity,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "initDegreeFromUniversity", $$v);
      },
      expression: "infoForm.initDegreeFromUniversity"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "初始学历毕业专业",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "initDegreeGraduationMajor"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择初始学历毕业专业",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.initDegreeGraduationMajor,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "initDegreeGraduationMajor", $$v);
      },
      expression: "infoForm.initDegreeGraduationMajor"
    }
  }, _vm._l(_vm.graduationMajorDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "初始学历学习形式",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "initAcademicOfStudy"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择初始学历学习形式",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.initAcademicOfStudy,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "initAcademicOfStudy", $$v);
      },
      expression: "infoForm.initAcademicOfStudy"
    }
  }, _vm._l(_vm.initAcademicOfStudyDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "初始学历学制",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "initOfSchooling"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择初始学历学制",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.initOfSchooling,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "initOfSchooling", $$v);
      },
      expression: "infoForm.initOfSchooling"
    }
  }, _vm._l(_vm.initOfSchoolingDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "初始学历学位",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "initDegreeGraduate"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入初始学历学位",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.initDegreeGraduate,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "initDegreeGraduate", $$v);
      },
      expression: "infoForm.initDegreeGraduate"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "初始学历毕业证编号",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "initDiplomaCertNumber"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入初始毕业证编号",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.initDiplomaCertNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "initDiplomaCertNumber", $$v);
      },
      expression: "infoForm.initDiplomaCertNumber"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "初始学历学位证书编号",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "initDegreeCertNumber"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入初始毕业证编号",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.initDegreeCertNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "initDegreeCertNumber", $$v);
      },
      expression: "infoForm.initDegreeCertNumber"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "最高学历",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "highestDegree"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入最高学历",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.highestDegree,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "highestDegree", $$v);
      },
      expression: "infoForm.highestDegree"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "最高学历毕业时间",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "highestGraduationDate"
    }
  }, [_c('a-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择最高学历毕业时间",
      "disabled": _vm.mode == 'view',
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.infoForm.highestGraduationDate,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "highestGraduationDate", $$v);
      },
      expression: "infoForm.highestGraduationDate"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "最高学历毕业院校",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "highestDegreeFromUniversity"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入最高学历毕业院校",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.highestDegreeFromUniversity,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "highestDegreeFromUniversity", $$v);
      },
      expression: "infoForm.highestDegreeFromUniversity"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "最高学历毕业专业",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "highestDegreeGraduationMajor"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择最高学历毕业专业",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.highestDegreeGraduationMajor,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "highestDegreeGraduationMajor", $$v);
      },
      expression: "infoForm.highestDegreeGraduationMajor"
    }
  }, _vm._l(_vm.graduationMajorDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "最高学历学习形式",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "highestAcademicOfStudy"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择初始学历学习形式",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.highestAcademicOfStudy,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "highestAcademicOfStudy", $$v);
      },
      expression: "infoForm.highestAcademicOfStudy"
    }
  }, _vm._l(_vm.initAcademicOfStudyDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "最高学历学制",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "highestOfSchooling"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择最高学历学制",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.highestOfSchooling,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "highestOfSchooling", $$v);
      },
      expression: "infoForm.highestOfSchooling"
    }
  }, _vm._l(_vm.initOfSchoolingDict, function (item) {
    return _c('a-select-option', {
      key: item.code
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "最高学历学位",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "highestDegreeGraduate"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入最高学历学位",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.highestDegreeGraduate,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "highestDegreeGraduate", $$v);
      },
      expression: "infoForm.highestDegreeGraduate"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "最高学历毕业证编号",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "highestDiplomaCertNumber"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入最高学历毕业证编号",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.highestDiplomaCertNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "highestDiplomaCertNumber", $$v);
      },
      expression: "infoForm.highestDiplomaCertNumber"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "最高学历学位证书编号",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "highestDegreeCertNumber"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入最高学历学位证书编号",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.highestDegreeCertNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "highestDegreeCertNumber", $$v);
      },
      expression: "infoForm.highestDegreeCertNumber"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "专业特长",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "proExpertise"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入专业特长",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.proExpertise,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "proExpertise", $$v);
      },
      expression: "infoForm.proExpertise"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "境外学习经历",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "overseasStudy"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择境外学习经历",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.overseasStudy,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "overseasStudy", $$v);
      },
      expression: "infoForm.overseasStudy"
    }
  }, _vm._l(_vm.overseasStudyDict, function (item) {
    return _c('a-select-option', {
      key: item.id
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "info-title",
    attrs: {
      "id": "gzjl"
    }
  }, [_c('span', [_vm._v("工作经历")])]), _c('div', {
    staticClass: "form-content"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "原工作单位",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "originalWorkUnit"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入原工作单位",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.originalWorkUnit,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "originalWorkUnit", $$v);
      },
      expression: "infoForm.originalWorkUnit"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "参工时间",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "workOfTime"
    }
  }, [_c('a-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择参工时间",
      "disabled": _vm.mode == 'view',
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.infoForm.workOfTime,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "workOfTime", $$v);
      },
      expression: "infoForm.workOfTime"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "进本单位时间",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "enterOrganTime"
    }
  }, [_c('a-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择进本单位时间",
      "disabled": _vm.mode == 'view',
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.infoForm.enterOrganTime,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "enterOrganTime", $$v);
      },
      expression: "infoForm.enterOrganTime"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "进本体系时间",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "enterSystemTime"
    }
  }, [_c('a-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择进本体系时间",
      "disabled": _vm.mode == 'view',
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.infoForm.enterSystemTime,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "enterSystemTime", $$v);
      },
      expression: "infoForm.enterSystemTime"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "离职时间",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "resignationTime"
    }
  }, [_c('a-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择离职时间",
      "disabled": _vm.mode == 'view',
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.infoForm.resignationTime,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "resignationTime", $$v);
      },
      expression: "infoForm.resignationTime"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "info-title",
    attrs: {
      "id": "gwxx"
    }
  }, [_c('span', [_vm._v("岗位信息")])]), _c('div', {
    staticClass: "form-content"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "部门",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "department"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入部门",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.department,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "department", $$v);
      },
      expression: "infoForm.department"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "岗位",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "post"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入岗位",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.post,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "post", $$v);
      },
      expression: "infoForm.post"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "年级",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "grade"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入年级",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.grade,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "grade", $$v);
      },
      expression: "infoForm.grade"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "所在学部",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "inDepartment"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入所在学部",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.inDepartment,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "inDepartment", $$v);
      },
      expression: "infoForm.inDepartment"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否绵中编制",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "isRegularEmployee"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择是否绵中编制",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.isRegularEmployee,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "isRegularEmployee", $$v);
      },
      expression: "infoForm.isRegularEmployee"
    }
  }, _vm._l(_vm.isRegularEmployeeDict, function (item) {
    return _c('a-select-option', {
      key: item.id
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否任课教师",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "isTeacher"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择是否任课教师",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.isTeacher,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "isTeacher", $$v);
      },
      expression: "infoForm.isTeacher"
    }
  }, _vm._l(_vm.isTeacherDict, function (item) {
    return _c('a-select-option', {
      key: item.id
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "学科",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "subject"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入所在学科",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "subject", $$v);
      },
      expression: "infoForm.subject"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "所属层级",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "level"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择所属层级",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.level,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "level", $$v);
      },
      expression: "infoForm.level"
    }
  }, [_vm._l(_vm.levelDictTree, function (item) {
    return _c('a-select-opt-group', {
      key: item.id,
      attrs: {
        "label": item.name
      }
    }, _vm._l(item.children, function (opt) {
      return _c('a-select-option', {
        key: opt.code
      }, [_vm._v(" " + _vm._s(opt.name) + " ")]);
    }), 1);
  }), _vm._l(_vm.levelDictOpt, function (opt) {
    return _c('a-select-option', {
      key: opt.code
    }, [_vm._v(" " + _vm._s(opt.name) + " ")]);
  })], 2)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "info-title",
    attrs: {
      "id": "jszgz"
    }
  }, [_c('span', [_vm._v("教师资格证")])]), _c('div', {
    staticClass: "form-content"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否取得教师资格",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "isTeaching"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择是否取得教师资格",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.isTeaching,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "isTeaching", $$v);
      },
      expression: "infoForm.isTeaching"
    }
  }, _vm._l(_vm.isTeachingDict, function (item) {
    return _c('a-select-option', {
      key: item.id
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "教师资格证种类",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "teachCertType"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入教师资格证种类",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.teachCertType,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "teachCertType", $$v);
      },
      expression: "infoForm.teachCertType"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "教师资格证学科",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "teacherCertSubject"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入教师资格证学科",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.teacherCertSubject,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "teacherCertSubject", $$v);
      },
      expression: "infoForm.teacherCertSubject"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "教师资格证书编号",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "teacherCertNumber"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入教师资格证书编号",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.teacherCertNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "teacherCertNumber", $$v);
      },
      expression: "infoForm.teacherCertNumber"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "认定机构",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "certOrgan"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入认定机构",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.certOrgan,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "certOrgan", $$v);
      },
      expression: "infoForm.certOrgan"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "info-title",
    attrs: {
      "id": "pthzs"
    }
  }, [_c('span', [_vm._v("普通话证书")])]), _c('div', {
    staticClass: "form-content"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "普通话等级",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "mandarinLevel"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入普通话等级",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.mandarinLevel,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "mandarinLevel", $$v);
      },
      expression: "infoForm.mandarinLevel"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "普通话证书编号",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "mandarinNumber"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入普通话证书编号",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.mandarinNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "mandarinNumber", $$v);
      },
      expression: "infoForm.mandarinNumber"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "普通话发证时间",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "mandarinCertTime"
    }
  }, [_c('a-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择普通话发证时间",
      "disabled": _vm.mode == 'view',
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.infoForm.mandarinCertTime,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "mandarinCertTime", $$v);
      },
      expression: "infoForm.mandarinCertTime"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "info-title",
    attrs: {
      "id": "zczs"
    }
  }, [_c('span', [_vm._v("职称证书")])]), _c('div', {
    staticClass: "form-content"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "职称资格名称",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "professionalName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入职称资格名称",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.professionalName,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "professionalName", $$v);
      },
      expression: "infoForm.professionalName"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "职称专业名称",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "professionalTitle"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入职称专业名称",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.professionalTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "professionalTitle", $$v);
      },
      expression: "infoForm.professionalTitle"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "评审组织",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "reviewOrgan"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入评审组织",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.reviewOrgan,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "reviewOrgan", $$v);
      },
      expression: "infoForm.reviewOrgan"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "审批机关",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "examOrgan"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入审批机关",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.examOrgan,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "examOrgan", $$v);
      },
      expression: "infoForm.examOrgan"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "职称证书编号",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "professionalCertNumber"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入职称证书编号",
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.infoForm.professionalCertNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.infoForm, "professionalCertNumber", $$v);
      },
      expression: "infoForm.professionalCertNumber"
    }
  })], 1)], 1)], 1)], 1)]), _c('div', {
    staticClass: "info-title",
    attrs: {
      "id": "qmtp"
    }
  }, [_c('span', [_vm._v("签名图片")])]), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start",
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a-upload', {
    attrs: {
      "action": "api/personArchivesController/uploadImg",
      "list-type": "picture-card",
      "file-list": _vm.fileList,
      "headers": _vm.headers,
      "showUploadList": {
        showRemoveIcon: _vm.mode != 'view'
      },
      "accept": ".jpg,.png"
    },
    on: {
      "preview": _vm.handlePreview,
      "change": _vm.handleChange
    }
  }, [_vm.fileList.length < 1 && _vm.mode != 'view' ? _c('div', [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _c('div', {
    staticClass: "ant-upload-text"
  }, [_vm._v("Upload")])], 1) : _vm._e()]), _c('a-button', {
    staticStyle: {
      "margin-left": "8px",
      "margin-top": "8px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showSignatureEditor
    }
  }, [_vm._v(" 手写签名 ")])], 1), _c('div', {
    staticStyle: {
      "margin-left": "24px",
      "display": "inline-block",
      "vertical-align": "top"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "border": "1px solid #d9d9d9",
      "border-radius": "4px"
    },
    attrs: {
      "src": require("@/assets/img/小程序.png"),
      "alt": ""
    }
  }), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "font-size": "12px",
      "color": "#666",
      "text-align": "center"
    }
  }, [_c('div', [_vm._v(" 扫码跳转 ")]), _c('div', [_vm._v("个人中心—>个人档案")]), _c('div', [_vm._v("进行签名上传")])])]), _c('a-modal', {
    attrs: {
      "visible": _vm.previewVisible,
      "footer": null,
      "centered": true
    },
    on: {
      "cancel": _vm.handleCancel
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "example",
      "src": _vm.previewImage
    }
  })])], 1), _c('a-modal', {
    attrs: {
      "title": "手写签名",
      "visible": _vm.signatureModalVisible,
      "width": 800,
      "okText": "确定",
      "cancelText": "取消"
    },
    on: {
      "ok": _vm.saveSignature,
      "cancel": function cancel($event) {
        _vm.signatureModalVisible = false;
      }
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #d9d9d9",
      "border-radius": "4px"
    }
  }, [_c('canvas', {
    ref: "signatureCanvas",
    staticStyle: {
      "border-bottom": "1px solid #d9d9d9",
      "cursor": "crosshair",
      "display": "block",
      "background-color": "#fff",
      "width": "100%",
      "height": "300px"
    },
    on: {
      "mousedown": _vm.startSignature,
      "mousemove": _vm.drawSignature,
      "mouseup": _vm.endSignature,
      "mouseleave": _vm.endSignature
    }
  }), _c('div', {
    staticStyle: {
      "padding": "8px",
      "text-align": "center"
    }
  }, [_c('a-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    on: {
      "click": _vm.clearSignatureCanvas
    }
  }, [_vm._v("清空")])], 1)])]), _c('div', {
    staticClass: "white-content"
  })], 1)])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };